<template>
    <div class="shipping__method">
        <ShippingSummary :address="address" :shipping_method="shipping_method" />
        <div class="shipping__method__header">
            <span class="shipping__method__header__title">نحوه پرداخت</span>
        </div>
        <div class="shipping__method__body" v-for="method in methods">
            <div class="shipping__method__body__content">
                <div class="shipping__method__body__header">
                <span class="shipping__method__body__item shipping__method__body__title">
                    <label
                        :for="method.key"
                        class="shipping__method__body__button"
                        :class="{'shipping__method__body__button___active' : paymentMethod === method.key}"
                        @click="setPaymentMethod(method.key)"
                    >
                        <input type="radio" name="paymentMethod" :id="method.key">
                        <span class="shipping__method__body__button__icon"></span>
                        <span class="shipping__method__body__button__label">{{method.title}}</span>
                    </label>
                </span>
                </div>
                <div class="shipping__method__body__description">
                    <p>{{method.description}}</p>
                    <div class="shipping__method__body__description__text" v-if="method.text" v-html="method.text"></div>
                </div>
            </div>
        </div>
        <Coupon @update:coupon="setCoupon" :coupons="coupons" />
        <div class="shipping__method__footer">
            <a href="#" @click="back"><span class="icon-Chevron_right"></span>بازگشت به شیوه ارسال</a>
        </div>
    </div>
</template>

<script>
import ShippingSummary from "./ShippingSummary";
import Coupon from "./Coupon";
export default {
    name: "Payment",
    components: {Coupon, ShippingSummary},
    emits: ['update:coupon', 'update:paymentMethod', 'back'],
    props: ['address', 'shipping_method', 'methods', 'coupons', 'coupon', 'paymentMethod'],
    methods: {
        back() {
            this.$emit('back');
        },
        setCoupon(coupon) {
            this.$emit('update:coupon', coupon);
        },
        setPaymentMethod(payment_method) {
            this.$emit('update:paymentMethod', payment_method);
        }
    }
}
</script>

<style scoped>

</style>
